import '../../../../../../vendor/assets/javascripts/jquery.countdown';

const auctionCountdown = '[data-bind=countdown]';
const millisecondsInASecond = 1000;
const secondsInAnHour = 3600;

function init() {
  if (lessThanAnHourLeft()) {
    bindCountdown();
  }
}

function bindCountdown() {
  $(auctionCountdown).countdown(endTime(), function (event) {
    $(this).html(event.strftime('%Mm %Ss'));
  });
}

function lessThanAnHourLeft() {
  const now = new Date();
  const millisecondsLeft = (endTime() - now);
  const secondsLeft = millisecondsToSecond(millisecondsLeft);
  return secondsLeft < secondsInAnHour;
}

function endTime() {
  const endTimeInSeconds = $(auctionCountdown).data('end_time');
  return new Date(secondsToMilliseconds(endTimeInSeconds));
}

function secondsToMilliseconds(seconds) {
  return seconds * millisecondsInASecond;
}

function millisecondsToSecond(milliseconds) {
  return milliseconds / millisecondsInASecond;
}

export default {
  init,
  lessThanAnHourLeft,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/countdown.js